import { apiFetchWeb } from "@/hooks/apiFetchWeb"

export const websiteOrderService = {
  getOrders: async (signal?: AbortSignal) =>
    apiFetchWeb("website/customer/orders", {
      signal,
    }),
  cancelOrder: async (orderId: number) =>
    apiFetchWeb(`website/customer/orders/${orderId}/cancel`, {
      method: "POST",
    }),
  requestReturn: async (
    orderId: number,
    body: {
      items: { product_id: number; quantity: number; reason: string }[]
      notes: string
    }
  ) =>
    apiFetchWeb(`website/customer/orders/${orderId}/return-request`, {
      method: "POST",
      body: JSON.stringify(body),
    }),
  getOrder: async (orderId: number, signal?: AbortSignal) =>
    apiFetchWeb(`order/${orderId}`, {
      signal,
    }),
}
